import React, { useState, useEffect, useMemo } from "react"
import { post, get } from "./../utils/apiClient"
import { FAX_ACTION } from "./../utils/constants"
import {
  validateFaxNumberOnlyDigit,
  formatFaxNumber,
  prepareFinalFaxNumber,
  isEmpty,
  getFaxNumberToDisplayOutbound,
  getFaxNumberToDisplayInbound,
} from "./../utils/common"
import toast from "react-hot-toast"
import { FaxNumberToolTip } from "./common/faxNumberToolTip"

import { X } from "lucide-react"

import ViewTab from "./faxTabs/view"
import History from "./faxTabs/history"

const viewTabs = [
  {
    key: "view",
    label: "View",
  },
  // {
  //   key: "forward_to_user",
  //   label: "Forward to User",
  // },
  // {
  //   key: "forward_to_fax",
  //   label: "Forward to Fax",
  // },
  {
    key: "history",
    label: "History",
  },
]

const FaxView = ({
  selectedFax,
  fetchFaxes,
  tab,
  selectedPractice,
  authUser,
  onClose,
  style,
}) => {
  const [loading, setLoading] = useState(false)
  const [document, setDocument] = useState(null)
  const [selectedViewTab, setSelectedViewTab] = useState(viewTabs[0].key) // Default to first tab
  const [showCancelPopup, setShowCancelPopup] = useState(null)
  const [showFFPopup, setShowFFPopup] = useState(false)
  const [showFUPopup, setShowFUPopup] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)
  // const faxNumberToDisplay =
  //   tab === "outbound"
  //     ? selectedFax.destination_fax_csid
  //     : selectedFax.originating_fax_tsid

  const faxNumberToDisplay =
    selectedPractice?.type === "subfolder"
      ? selectedFax?.faxNumber
      : tab === "outbound"
        ? getFaxNumberToDisplayOutbound(selectedFax)
        : getFaxNumberToDisplayInbound(selectedFax)

  const showFrwdBottons = selectedPractice.faxNumberAttributes.length === 0

  const handleTabClick = (key) => {
    setSelectedViewTab(key) // Update selected tab on click
  }

  const fetchFax = async () => {
    try {
      setLoading(true)

      let headers = { appId: selectedFax?.appId }
      if (selectedPractice?.type !== "subfolder") {
        headers = {
          faxNumber: selectedFax?.faxNumber,
          faxAction: FAX_ACTION[tab],
          appId: selectedFax?.appId,
          originatingFaxNumber: faxNumberToDisplay,
        }
      }

      const data = await post(
        `/fax/image`,
        {
          userId: selectedFax?.userId,
          faxId: selectedFax.fax_id,
        },
        headers,
      )

      if (data?.image) {
        // const byteCharacters = atob(data?.image)
        // const byteNumbers = new Array(byteCharacters.length)
        // for (let i = 0; i < byteCharacters.length; i++) {
        //   byteNumbers[i] = byteCharacters.charCodeAt(i)
        // }
        // const byteArray = new Uint8Array(byteNumbers)
        // const blob = new Blob([byteArray], { type: "application/pdf" })

        // // Update state to pass the Blob to the Document component
        // setPdfUrl(blob)
        setDocument(data?.image)
      } else {
        setDocument(null)
      }

      setLoading(false)
    } catch (err) {
      setLoading(false)
      setDocument(null)
    }
  }

  const renderTabContent = () => {
    switch (selectedViewTab) {
      case "view":
        return (
          // <ViewTab
          //   fax={fax}
          //   pdfUrl={pdfUrl}
          //   selectedFax={selectedFax}
          //   loading={loading}
          // />
          <ViewTab
            base64String={document}
            selectedFax={selectedFax}
            loading={loading}
          />
        )
      case "history":
        return (
          <History
            selectedFax={selectedFax}
            faxNumberToDisplay={formatFaxNumber(faxNumberToDisplay)}
            authUser={authUser}
          />
        )
      default:
        return <div>Please select a tab</div>
    }
  }

  const handleSendFax = async (data) => {
    // const formData = new FormData()
    // formData.append("sendFaxDataRequest", JSON.stringify(data))

    setActionLoading(true)
    try {
      await post("/fax/sendfax", data, {
        appId: data?.appId,
        faxAction: FAX_ACTION.forwardToFax,
        originatingFaxNumber: faxNumberToDisplay,
        faxNumber: selectedFax?.faxNumber,
      })

      setShowFFPopup(null)
      setActionLoading(false)
      toast.success("Fax has been sent successfully", {
        duration: 5000,
      })
    } catch (error) {
      console.error("Failed to send fax", error)

      const message = error.message || "An unexpected error occurred."
      toast.error(message, {
        duration: 5000,
      })
      setActionLoading(false)
    }
  }

  const handleSendToUser = async (data) => {
    setActionLoading(true)

    try {
      await post("/fax/forwardFax", data, {
        appId: data?.appId,
        faxNumber: selectedFax?.faxNumber,
        faxAction: FAX_ACTION.forwardToUser,
        originatingFaxNumber: faxNumberToDisplay,
      })
      setShowFUPopup(null)
      setActionLoading(false)
      toast.success("Fax has been forwarded successfully", {
        duration: 5000,
      })
    } catch (error) {
      console.error("Failed to forward fax", error)
      const message = error.message || "An unexpected error occurred."
      toast.error(message, {
        duration: 5000,
      })
      setActionLoading(false)
    }
  }

  const handleCancelFax = async () => {
    setActionLoading(true)
    try {
      await post(
        "/fax/cancel",
        {
          userId: selectedFax?.userId,
          faxId: showCancelPopup,
        },
        {
          appId: selectedPractice?.appId,
          faxAction: FAX_ACTION.cancel,
          originatingFaxNumber: faxNumberToDisplay,
          faxNumber: selectedFax?.faxNumber,
        },
      )

      toast.success("Fax has been cancelled successfully", {
        duration: 5000,
      })
      setActionLoading(false)
      setShowCancelPopup(null)
      fetchFaxes()
    } catch (error) {
      console.error("Failed to cancel user", error)
      const message = error.message || "An unexpected error occurred."
      toast.error(message, {
        duration: 5000,
      })
      setActionLoading(false)
    }
  }

  useEffect(() => {
    if (selectedFax?.fax_id) fetchFax()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFax?.fax_id])

  return (
    <div className="fax-view" style={style}>
      {/* {(selectedPractice?.type !== "subfolder" || showFrwdBottons) && ( */}
      <div
        className="fax-view-data"
        style={{
          flexDirection: "row",
          alignItems: "flex-start",
          justifyContent: "space-between",
          marginTop: "0px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <div className="data-item">
            <span className="data-label">Fax Number:</span>
            <span className="data-value">
              {formatFaxNumber(faxNumberToDisplay)}
            </span>
          </div>
          <div className="data-item">
            <span className="data-label">Fax Id:</span>
            <span className="data-value">{selectedFax.fax_id}</span>
          </div>
        </div>
        <button
          onClick={onClose}
          title="Close"
          style={{
            background: "transparent",
            border: "none",
            fontSize: 16,
            lineHeight: 1,
            cursor: "pointer",
            color: "#555",
            padding: 0,
          }}
        >
          <X size={16} color="#000" style={{ cursor: "pointer" }} />
        </button>
      </div>
      {/* )} */}

      <div className="fax-view-tabs">
        {viewTabs.map((viewTab) => (
          <div
            key={viewTab.key}
            className={`tab ${
              selectedViewTab === viewTab.key ? "selected" : ""
            }`}
            onClick={() => handleTabClick(viewTab.key)}
          >
            {viewTab.label}
          </div>
        ))}
      </div>

      <div className="fax-view-image">{renderTabContent()}</div>
      {/* {(selectedPractice?.type !== "subfolder" || showFrwdBottons) && (
        <>
          {selectedViewTab === "view" &&
            ((tab === "outbound" &&
              ["NEW", "INPROGRESS"].includes(
                selectedFax?.transmission_data?.transmission_status,
              )) ||
              document) && (
              <div className="fax-view-button">
                <div className="fax-view-buttons">
                  {document ? (
                    <>
                      <button
                        className="faxes-button"
                        onClick={(e) => {
                          handleFUFaxes(
                            e,
                            selectedFax?.fax_id,
                            selectedFax?.originating_fax_number,
                          )
                        }}
                      >
                        Forward to User
                      </button>
                      <button
                        className="faxes-button"
                        onClick={(e) => {
                          handleSendFaxes(selectedFax?.fax_id)
                        }}
                      >
                        Forward to Fax
                      </button>
                    </>
                  ) : (
                    <>&nbsp;</>
                  )}

                  {tab === "outbound" &&
                  ["NEW", "INPROGRESS"].includes(
                    selectedFax?.transmission_data?.transmission_status,
                  ) ? (
                    <button
                      className="faxes-button"
                      onClick={(e) => {
                        setShowCancelPopup(selectedFax?.fax_id)
                      }}
                    >
                      Cancel Fax
                    </button>
                  ) : (
                    <>&nbsp;</>
                  )}
                </div>
              </div>
            )}
        </>
      )} */}

      {showCancelPopup && (
        <CancelConfirmationPopup
          showCancelPopup={showCancelPopup}
          onConfirm={() => handleCancelFax()}
          onCancel={() => setShowCancelPopup(null)}
          actionLoading={actionLoading}
        />
      )}

      {showFFPopup && (
        <SendFaxForm
          onSave={handleSendFax}
          actionLoading={actionLoading}
          onClose={() => {
            setShowFFPopup(null)
          }}
          selectedPractice={selectedPractice}
          selectedFax={selectedFax}
          // document={document}
        />
      )}

      {showFUPopup && (
        <SendUserForm
          onSave={handleSendToUser}
          actionLoading={actionLoading}
          onClose={() => {
            setShowFUPopup(null)
          }}
          selectedPractice={selectedPractice}
          selectedFax={selectedFax}
          document={document}
        />
      )}
    </div>
  )
}

export default FaxView

const SendFaxForm = ({
  onClose,
  onSave,
  actionLoading,
  selectedPractice,
  selectedFax,
  //document,
}) => {
  const [toName, setToName] = useState("")
  const [toCompany, setToCompany] = useState("")
  const [faxNumber, setFaxNumber] = useState("")
  const [comment1, setComment1] = useState("")
  const [comment2, setComment2] = useState("")
  const [includeCoverPage, setIncludeCoverPage] = useState(false)
  const [fromName, setFromName] = useState("")
  const [subject, setSubject] = useState("")
  const [message, setMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [destinationFaxNumberLoading, setDestinationFaxNumberLoading] =
    useState(false)
  const [destinationfaxNumbers, setDestinationfaxNumbers] = useState([])

  const fetchDestinationFaxNumbers = async () => {
    setDestinationFaxNumberLoading(true)

    // let type = "PERSONAL"
    // let qString = ""
    // if (showComposePopup?.section === "queue" && selectedQueueOrNetId) {
    //   type = "QUEUE"
    //   qString = `?queue=${selectedQueueOrNetId}`
    // }

    try {
      const faxNumbers = await get(
        `/phonebook/phonebooksByPractice?practiceName=${selectedPractice?.practiceName}`,
      )

      setDestinationfaxNumbers(faxNumbers)
      setDestinationFaxNumberLoading(false)
    } catch (error) {
      console.error("Failed to fetch fetchFaxNumbers", error)
      setDestinationFaxNumberLoading(false)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!faxNumber) {
      setErrorMessage("Fax Number is required.")
      return
    } else {
      const errorMsg = validateFaxNumberOnlyDigit(faxNumber?.trim())

      if (errorMsg) {
        setErrorMessage(errorMsg)
        return
      }
    }

    // if (includeCoverPage && (!fromName || !subject || !message)) {
    //   setErrorMessage("All cover page fields must be filled if included.")
    //   return
    // }

    const formData = {
      destinations: [
        {
          to_name: toName,
          to_company: toCompany,
          fax_number: prepareFinalFaxNumber(faxNumber),
        },
      ],
      include_cover_page: includeCoverPage,
      coverPageOptions: includeCoverPage
        ? {
            from_name: includeCoverPage ? fromName : null,
            subject: includeCoverPage ? subject : null,
            message: includeCoverPage ? message : null,
          }
        : {},
      userId: selectedFax?.userId,
      faxId: selectedFax?.fax_id,
      appId: selectedFax?.appId,
      faxNumber: selectedFax?.faxNumber,
      comment1,
      comment2,
    }

    onSave(formData)
  }

  const optionDestinationFaxNumbers = destinationfaxNumbers.map((fax) => ({
    toName: `${fax.firstName} ${fax.lastName}`,
    toCompany: `${fax.company}`,
    value: fax.faxNumber,
    label: `${formatFaxNumber(fax.faxNumber)} | ${fax.firstName} ${
      fax.lastName
    } ${fax?.company ? `| ${fax?.company}` : ""}`,
  }))

  useEffect(() => {
    if (selectedPractice) {
      fetchDestinationFaxNumbers()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPractice])

  return (
    <div className="popup-overlay">
      <div className="popup">
        {actionLoading ? (
          <div className="loading" style={{ padding: "20px" }}>
            In Progress ...
          </div>
        ) : (
          <>
            <div className="checkbox-popup-header">
              <h3 className="popup-title">Forward to Fax</h3>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: 24,
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>
            <form
              className="popup-group form-container"
              onSubmit={handleSubmit}
            >
              <div className="form-group">
                <label htmlFor="email">
                  Fax Number: <span className="mandatory">*</span>
                  <FaxNumberToolTip />
                </label>
                {/* <input
                  type="text"
                  id="faxNumber"
                  value={faxNumber}
                  onChange={(e) => setFaxNumber(e.target.value)}
                /> */}

                {destinationFaxNumberLoading ? (
                  <div style={{ textAlign: "left", padding: "10px" }}>
                    Loading...
                  </div>
                ) : (
                  <FaxSearchInput
                    faxNumber={faxNumber}
                    setFaxNumber={setFaxNumber}
                    setToName={setToName}
                    setToCompany={setToCompany}
                    optionDestinationFaxNumbers={optionDestinationFaxNumbers}
                  />
                )}
              </div>

              <div className="form-group">
                <label htmlFor="toName">To Name:</label>
                <input
                  type="text"
                  id="toName"
                  value={toName}
                  onChange={(e) => setToName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="toCompany">To Company:</label>
                <input
                  type="text"
                  id="toCompany"
                  value={toCompany}
                  onChange={(e) => setToCompany(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="comment1">Comment1:</label>
                <input
                  type="text"
                  id="comment1"
                  value={comment1}
                  onChange={(e) => setComment1(e.target.value)}
                  maxLength={45}
                />
              </div>

              <div className="form-group">
                <label htmlFor="comment2">Comment2:</label>
                <input
                  type="text"
                  id="comment2"
                  value={comment2}
                  onChange={(e) => setComment2(e.target.value)}
                  maxLength={45}
                />
              </div>

              <div
                className="form-group checkbox-group"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                <div>
                  <input
                    type="checkbox"
                    id="includeCoverPage"
                    checked={includeCoverPage}
                    onChange={(e) => setIncludeCoverPage(e.target.checked)}
                    style={{ marginRight: "5px", width: "20px" }}
                  />
                </div>
                <div>
                  <label
                    htmlFor="includeCoverPage"
                    style={{
                      whiteSpace: "nowrap",
                      marginBottom: "0px",
                      cursor: "pointer",
                    }}
                  >
                    Include Cover Page
                  </label>
                </div>
              </div>

              {includeCoverPage && (
                <>
                  <div className="form-group">
                    <label htmlFor="fromName">From Name:</label>
                    <input
                      type="text"
                      id="fromName"
                      value={fromName}
                      onChange={(e) => setFromName(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Subject:</label>
                    <input
                      type="text"
                      id="subject"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Message:</label>
                    <textarea
                      id="message"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      style={{
                        width: "100%",
                        minHeight: "80px",
                        resize: "vertical",
                      }}
                    ></textarea>
                  </div>
                </>
              )}

              {errorMessage && (
                <div className="error-message">{errorMessage}</div>
              )}

              <div className="popup-buttons">
                <button
                  type="button"
                  className="popup-button cancel"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button type="submit" className="popup-button save">
                  Send
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  )
}

const SendUserForm = ({
  onClose,
  onSave,
  actionLoading,
  selectedPractice,
  selectedFax,
}) => {
  const [email, setEmail] = useState("")
  const [emailSubject, setEmailSubject] = useState("")
  const [emailMessage, setEmailMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!email) {
      setErrorMessage("Email is required.")
      return
    } else {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setErrorMessage("Email is incorrect.")
        return
      }
    }

    if (!emailSubject) {
      setErrorMessage("Subject is required.")
      return
    }

    if (!emailMessage) {
      setErrorMessage("Message is required.")
      return
    }

    const formData = {
      recipientEmail: email.trim(),
      subject: emailSubject,
      bodyText: emailMessage,
      userId: selectedFax?.userId,
      faxId: selectedFax?.fax_id,
      appId: selectedFax?.appId,
      faxNumber: selectedFax?.faxNumber,
    }

    onSave(formData)
  }

  return (
    <div className="popup-overlay">
      <div className="popup">
        {actionLoading ? (
          <div className="loading" style={{ padding: "20px" }}>
            In Progress ...
          </div>
        ) : (
          <>
            <div className="checkbox-popup-header">
              <h3 className="popup-title">Forward via Email</h3>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: 24,
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>
            <form
              className="popup-group form-container"
              onSubmit={handleSubmit}
            >
              <div className="form-group">
                <label htmlFor="email">
                  Email: <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="emailSubject">
                  Subject: <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  id="emailSubject"
                  value={emailSubject}
                  onChange={(e) => setEmailSubject(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="emailMessage">
                  Message: <span className="mandatory">*</span>
                </label>
                <textarea
                  id="emailMessage"
                  value={emailMessage}
                  onChange={(e) => setEmailMessage(e.target.value)}
                  style={{
                    width: "100%",
                    minHeight: "80px",
                    resize: "vertical",
                  }}
                ></textarea>
              </div>

              {errorMessage && (
                <div className="error-message">{errorMessage}</div>
              )}

              <div className="popup-buttons">
                <button
                  type="button"
                  className="popup-button cancel"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button type="submit" className="popup-button save">
                  Send
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  )
}

const CancelConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  showCancelPopup,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup" style={{ padding: "15px" }}>
        {actionLoading ? (
          <div>In progress ...</div>
        ) : (
          <div>
            {/* <h3>Confirm Deletion</h3> */}
            <p style={{ marginTop: "5px" }}>
              {`Are you sure you want to cancel the fax?`}
            </p>
            <div className="popup-buttons">
              <button className="cancel" onClick={onCancel}>
                No
              </button>
              <button className="delete" onClick={onConfirm}>
                Yes
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

function FaxSearchInput({
  faxNumber,
  setFaxNumber,
  setToName,
  setToCompany,
  optionDestinationFaxNumbers,
}) {
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState("")
  const [hoverIndex, setHoverIndex] = useState(null)

  // keep local query in sync with external faxNumber
  useEffect(() => {
    const v = typeof faxNumber === "string" ? faxNumber : faxNumber?.value || ""
    setQuery(v || "")
  }, [faxNumber])

  const filteredOptions = useMemo(() => {
    if (!query) return optionDestinationFaxNumbers || []
    const q = query.toLowerCase().trim().replace(/-/g, "")
    return (optionDestinationFaxNumbers || []).filter((opt) =>
      String(
        opt.label.trim().replace(/-/g, "") ||
          opt.value.trim().replace(/-/g, "") ||
          "",
      )
        .toLowerCase()
        .includes(q),
    )
  }, [query, optionDestinationFaxNumbers])

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <input
        id="faxNumber"
        name="faxNumber"
        type="text"
        placeholder="Enter a fax number"
        value={query}
        onChange={(e) => {
          const v = e.target.value
          setQuery(v)

          // keep same shape as react-select: { value, label }
          setFaxNumber(v || null)

          setOpen(true)
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => {
          // allow click to register before closing
          setTimeout(() => setOpen(false), 150)
        }}
        autoComplete="off" // disable browser suggestions
        autoCorrect="off"
        spellCheck={false}
        style={{
          width: "100%",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: 0,
        }}
      />

      {open && filteredOptions.length > 0 && (
        <ul className="fax-search-input-ul">
          {filteredOptions.map((opt, idx) => (
            <li
              key={opt.value}
              onMouseDown={(e) => {
                e.preventDefault() // prevent blur before click
                setQuery(formatFaxNumber(opt.value))

                setFaxNumber(formatFaxNumber(opt.value))
                // setToName(opt.toName)
                // setToCompany(opt.toCompany)

                setToName(isEmpty(opt.toName, true) ? "" : opt.toName)
                setToCompany(isEmpty(opt.toCompany, true) ? "" : opt.toCompany)

                setOpen(false)
              }}
              onMouseEnter={() => setHoverIndex(idx)}
              onMouseLeave={() => setHoverIndex(null)}
              style={{
                padding: "7px 10px",
                marginTop: idx === 0 ? "5px" : "0px",
                cursor: "pointer",
                backgroundColor:
                  hoverIndex === idx ? "#bedaf8ff" : "transparent", // 👈 hover effect
              }}
            >
              {opt.label || opt.value}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
